import { router } from "@inertiajs/react";

class FilterHandler {
  constructor() {
    this._params = new URLSearchParams(document.location.search);
  }

  get params() {
    return this.params;
  }

  get searchString() {
    return this._params.toString();
  }

  navigate(path = "") {
    router.visit(`${path}?${this._params.toString()}`, {
      except: ["filters"],
      preserveScroll: false,
    });
  }

  applyProductPropertyFilter(key, values) {
    if (values.length === 0) {
      this._params.delete(key);
    } else {
      this._params.set(key, values.join(","));
    }
  }

  applyPriceFilter(values) {
    this._params.set("filter[price]", values.join(","));
  }

  applyTaxonsFilter(values) {
    const key = "filter[taxons]";
    if (values.length === 0) {
      this.resetFilter(key);
    } else {
      this._params.set(key, values.join(","));
    }
  }

  resetFilter(key) {
    this._params.delete(key);
  }
}

export default FilterHandler;
